import React, { useEffect, useState } from "react";
import Navbar from "@/components/nexodiag/Navbar";
import Hero from "@/components/nexodiag/Hero";
import Services from "@/components/nexodiag/Services";
import HowItWorks from "@/components/nexodiag/HowItWorks";
import About from "@/components/nexodiag/About";
import Stats from "@/components/nexodiag/Stats";
import Testimonials from "@/components/nexodiag/Testimonials";
import Faq from "@/components/nexodiag/Faq";
import Contact from "@/components/nexodiag/Contact";
import Footer from "@/components/nexodiag/Footer";
import DemoModal from "@/components/nexodiag/DemoModal";
import Product from "@/components/nexodiag/Product";
import Performance from "@/components/nexodiag/Performance";
import ScoreScale from "@/components/nexodiag/ScoreScale";

const Home = () => {
  const [demoOpen, setDemoOpen] = useState(false);

  useEffect(() => {
    const els = document.querySelectorAll(".nx-fade");
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("visible");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    els.forEach((el) => io.observe(el));

    const openHandler = () => setDemoOpen(true);
    window.addEventListener("nx:open-demo", openHandler);

    return () => {
      io.disconnect();
      window.removeEventListener("nx:open-demo", openHandler);
    };
  }, []);

  return (
    <main data-testid="home-page" className="bg-[#060B19] text-white overflow-x-hidden">
      <Navbar />
      <Hero />
      <Stats />
      <Product />
      <Services />
      <HowItWorks />
      <ScoreScale />
      <Performance />
      <About />
      <Testimonials />
      <Faq />
      <Contact />
      <Footer />
      <DemoModal open={demoOpen} onClose={() => setDemoOpen(false)} />
    </main>
  );
};

export default Home;
